import {Button, Skeleton, Stack} from '@mui/material';
import React from 'react';

import Icon from 'presentation/icons';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {DotsContainer, StyledDotButton} from '../../styles';

const {next, prev} = translations['pt-br'].commons;

export function YouTubeBannerLoading() {
	const {isMobile} = useMediaQueries();

	return (
		<Stack>
			<Stack
				direction={'row'}
				justifyContent={'space-between'}
				width={'100%'}
				height={'180px'}
				spacing={2}
				overflow="hidden">
				<Skeleton sx={{transform: 'initial'}} width={'33%'} height={'100%'} />
				<Skeleton sx={{transform: 'initial'}} width={'33%'} height={'100%'} />
				<Skeleton sx={{transform: 'initial'}} width={'33%'} height={'100%'} />
			</Stack>
			{!isMobile ? (
				<DotsContainer>
					<Button
						disabled
						sx={{mr: 'auto', lineHeight: 0}}
						variant="text"
						size="small"
						startIcon={<Icon name="arrow-left-filled" size={18} />}>
						{prev}
					</Button>
					{Array.from(Array(3)).map((_, index) => (
						<StyledDotButton key={index} />
					))}
					<Button
						disabled
						sx={{ml: 'auto', lineHeight: 0}}
						variant="text"
						size="small"
						endIcon={<Icon name="arrow-right-filled" size={18} />}>
						{next}
					</Button>
				</DotsContainer>
			) : null}
		</Stack>
	);
}
